import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { ErrorBoundary } from "react-error-boundary";
const ErrorFallback = ({ error, resetErrorBoundary }) => {
    const errorDetails = error instanceof Error ? (error.stack ?? error.message) : String(error);
    return (_jsxs("div", { children: [_jsx("h2", { children: "\u4F55\u3089\u304B\u306E\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002" }), _jsx("button", { onClick: resetErrorBoundary, children: "\u5143\u306E\u30DA\u30FC\u30B8\u306B\u623B\u308B" }), _jsx("p", { children: "\u958B\u767A\u8005\u306B\u5831\u544A\u3059\u308B\u5834\u5408\u306F\u3001\u4EE5\u4E0B\u306E\u5185\u5BB9\u3092\u30B3\u30D4\u30FC\uFF06\u30DA\u30FC\u30B9\u30C8\u3057\u3066\u9001\u3063\u3066\u3044\u305F\u3060\u3051\u308B\u3068\u52A9\u304B\u308A\u307E\u3059\u3002" }), _jsx("textarea", { style: {
                    width: "100%",
                    border: "1px solid black",
                    padding: 8,
                    margin: `8px 0px`,
                    minHeight: 500,
                }, value: errorDetails, readOnly: true })] }));
};
export const ErrorBoundaryProvider = ({ children, }) => {
    return (_jsx(ErrorBoundary, { FallbackComponent: ErrorFallback, children: children }));
};
